/* import __COLOCATED_TEMPLATE__ from './reasons-bar-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { type ReasonData } from './reasons-interactive-bar';
import type IntlService from 'embercom/services/intl';
import { inject as service } from '@ember/service';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Signature {
  Args: {
    reason: string;
    reasonDescription: string;
    share: number;
    reasonData: ReasonData;
    icon: InterfaceIconName;
  };
}

export default class ReasonsBarTooltip extends Component<Signature> {
  @service declare intl: IntlService;

  get performanceText() {
    return this.intl.t(
      'automation.analyze.task-suggestions.suggestions.reason-bar-tooltip.performance',
      {
        team: this.args.reasonData.sentToTeammate.toFixed(0),
        resolved: this.args.reasonData.resolved.toFixed(0),
        unresolved: this.args.reasonData.unresolved.toFixed(0),
      },
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::ReasonsBarTooltip': typeof ReasonsBarTooltip;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/reasons-bar-tooltip': typeof ReasonsBarTooltip;
  }
}
